import { useTrans } from 'hooks'
import Icon from './Icon'
import React from 'react'

const Switch = ({ isChecked, handleToggle }) => {

  const t = useTrans()

  return (
    <div className="switch">
      <input
        checked={isChecked}
        onChange={handleToggle}
        className="switch__checkbox"
        id="switch__new"
        type="checkbox"
      />
      <label className="switch__label" htmlFor="switch__new" aria-label={t("Visualizzazione griglia")}>
        <img
          className="switch__image"
          src={!isChecked ? '/images/demo/masonry.png' : '/images/demo/grid.png'}
          style={{ marginLeft: isChecked ? 'auto' : 0 }}
          alt=""
        />
        <span className="switch__button">
          <Icon id={isChecked ? `masonry-view` : 'grid-view'} />
        </span>
      </label>
    </div>
  )
}

export default Switch
